// extracted by mini-css-extract-plugin
export default {"container":"pUVs9o","topSection":"I6mYOR","vetImage":"MpoEv9","subtitle":"JquFSK","information":"vC1mVa","informationList":"qD_6bQ","linkContainer":"NRbD1H","link":"y0tPl8"};